var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-24
 * @brief EHP 설비수명 - 수명인자 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import { loadingBoxState } from "../../../recoil/menuState";
import { useTrans } from "../../../utils/langs/useTrans";
import { useNavigate } from "react-router-dom";
/**
* @brief EHP 설비수명  - 수명인자 수정 컴포넌트, 반응형 동작
* @param -
* @returns react components
*/
//component
function DeviceLifeUpdate(props) {
    //trans
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //화면 이동
    const navigate = useNavigate();
    //props
    const isMobile = props.isMobile;
    const selTree = props.selTree;
    const workMode = props.workMode;
    const setParentCurTree = props.setCurTree;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    const reWork = props.reWork;
    const setReWork = props.setReWork;
    // by hjo - 20220920 - 추가 hook
    const setListWork = props.setListWork;
    const listItem = props.listItem;
    const setListItem = props.setListItem;
    const restart = props.restart;
    const setRestart = props.setRestart;
    const setNodata = props.setNodata;
    //
    const [list, setList] = useState([]);
    const [errorList, setErrorList] = useState([]);
    const [checkValueId, setCheckValueId] = useState([]);
    const [userInput, setUserInput] = useState([]);
    const [checkItemName, setCheckItemName] = useState([]);
    const [check, setChek] = useState(false);
    const [item, setItem] = useState([]);
    const { data: resInfo, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/assessment/devicelife`,
        appQuery: { itemIdPk: listItem.itemIdPk },
        userToken: userInfo.loginInfo.token,
        watch: listItem.itemIdPk
    });
    useEffect(() => {
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, resInfo);
        //clog("IN TREE : RESLT CHECK : " + ERR_URL + " : " + isLoading + " : " + JSON.stringify(resInfo));
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (resInfo /* !isLoading */) {
            if (resInfo.codeNum == CONST.API_200) {
                setList(resInfo.body.map((input) => (Object.assign(Object.assign({}, input), { "userInput": input.deviceLife.userInput, checkItemNamed: (!input.checkItemId) ? input.checkItemName : null, checked: (input.deviceLife.userInput) ? true : false }))));
            }
            else {
                alert(resInfo.errorList.map((err) => (err.msg)));
            }
        }
    }, [resInfo]);
    var userDefinedList = [];
    for (let i = 0; i < (20 - list.filter((val) => (val.stepName == "User Defined")).length); i++) {
        var userDefined = {
            checkItemId: null,
            number: list.length + (i + 1),
            stepName: "User Defined",
            checkItemName: null,
            checkItemNamed: null,
            refAnswer: null,
            userInput: null,
            checked: false,
            deviceLife: { deviceLifeId: null, userInput: null }
        };
        userDefinedList.push(userDefined);
    }
    let updatelist = [...list, ...userDefinedList];
    function checkedList(checked, idx) {
        if (checked) {
            setList(updatelist.map((smenu) => (smenu.number === idx)
                ? Object.assign(Object.assign({}, smenu), { checked: checked }) : smenu));
        }
        else {
            setList(updatelist.map((smenu) => (smenu.number === idx)
                ? Object.assign(Object.assign({}, smenu), { checked: checked }) : smenu));
        }
    }
    ;
    //사용자 입력값
    function handleUserInput(e, idx) {
        setErrorList(errorList.filter((err) => (err.field !== "userInput")));
        setList(updatelist.map((smenu) => (smenu.number === idx)
            ? Object.assign(Object.assign({}, smenu), { userInput: e.target.value }) : smenu));
        // setUserInput({ ...userInput, [idx]: value });
    }
    //userundefined 
    function handleCheckItemName(e, idx) {
        setErrorList(errorList.filter((err) => (err.field !== "checkItemName")));
        setList(updatelist.map((smenu) => (smenu.number === idx)
            ? Object.assign(Object.assign({}, smenu), { checkItemNamed: e.target.value }) : smenu));
    }
    // 저장 팝업 
    useEffect(() => {
        setParentPopWin("pop-change", React.createElement(ChanagePop, { htmlHeaderBtn: React.createElement("button", { className: "btn btn-close js-close" },
                React.createElement("span", { className: "hide" }, "\uB2EB\uAE30")), setRecoilIsLoadingBox: setRecoilIsLoadingBox, item: item, listItem: listItem, setErrorList: setErrorList, setParentWorkMode: setParentWorkMode }));
        // tree 변화 시 오류 리스트로 이동
        if (reWork.room.roomId != selTree.room.roomId) {
            setParentWorkMode("READ");
        }
    });
    // change pop
    function savedPop(e, updatelist) {
        let curItem = [];
        updatelist.filter((fval) => (fval.checked)).forEach((el) => (curItem.push({
            checkItemId: el.checkItemId,
            userInput: el.userInput,
            checkItemName: el.checkItemNamed,
            number: el.number
        })));
        setItem((item) => { return Object.assign(Object.assign({}, item), { curItem }); });
        CUTIL.jsopen_Popup(e);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right" },
            React.createElement("ul", { className: "page-loca" },
                React.createElement("li", null, selTree.company.companyName),
                React.createElement("li", null, selTree.zone.zoneName),
                React.createElement("li", null, selTree.subZone.subZoneName),
                React.createElement("li", null, selTree.room.roomName)),
            React.createElement("h2", null, selTree.room.roomName),
            React.createElement("div", { className: "inline mb-18" },
                React.createElement("a", { href: "#", className: "move-list ", onClick: (e) => setParentWorkMode("READ") }, "Device List"),
                React.createElement("a", { href: "#", className: "move-list active" }, t("LABEL.수명인자설정"))),
            React.createElement("div", { className: "area__right_content scrollH-no" },
                React.createElement("div", { className: "tbl__top mb-16 mt-12 d-lm-block" },
                    React.createElement("div", { className: "left" },
                        React.createElement("p", { className: "title" },
                            "Device  ",
                            t("LABEL.정보")))),
                React.createElement("div", { className: "tbl-list td-h26 h-auto" },
                    React.createElement("table", { summary: "\uC124\uBE44 \uBA85,Panel \uBA85,\uBAA8\uB378 \uBA85,\uC2DC\uB9AC\uC5BC \uBC88\uD638,\uC815\uACA9\uC804\uC555,Basic,Premium,Advanced \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C Device \uC815\uBCF4 \uC785\uB2C8\uB2E4." },
                        React.createElement("caption", null,
                            "Device ",
                            t("LABEL.정보")),
                        React.createElement("colgroup", null,
                            React.createElement("col", { style: {} })),
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("FIELD.기기명"))),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("FIELD.Panel명"))),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("FIELD.모델명"))),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("FIELD.시리얼번호"))),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("FIELD.정격전압"))),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("Basic"))),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("Premium"))),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    React.createElement("span", null, t("Advanced"))))),
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("td", { className: "txt-left" }, (listItem.spg.spgName) ? listItem.spg.spgName : "-"),
                                React.createElement("td", { className: "txt-left" },
                                    React.createElement("p", { className: "ellipsis w100p" }, (listItem.panel.panelName) ? listItem.panel.panelName : "-")),
                                React.createElement("td", { className: "txt-left" },
                                    React.createElement("p", { className: "ellipsis w100p" }, (listItem.modelName) ? listItem.modelName : "-")),
                                React.createElement("td", { className: "txt-left" },
                                    React.createElement("p", { className: "ellipsis w100p" }, (listItem.serialNo) ? listItem.serialNo : "-")),
                                React.createElement("td", { className: "txt-left" }, (listItem.ratingVoltage) ? listItem.ratingVoltage : "-"),
                                React.createElement("td", { className: "txt-left" }, (listItem.basicAssess.totalScore !== null) ? listItem.basicAssess.totalScore : "-"),
                                React.createElement("td", { className: "txt-left" }, (listItem.premiumAssess.totalScore !== null) ? listItem.premiumAssess.totalScore : "-"),
                                React.createElement("td", { className: "txt-left" }, (listItem.advancedAssess.totalScore !== null) ? listItem.advancedAssess.totalScore : "-"))))),
                React.createElement("div", { className: "tbl__top mb-16 mt-32 d-lm-block" },
                    React.createElement("div", { className: "left" },
                        React.createElement("p", { className: "title" },
                            t("LABEL.설정항목"),
                            " ")),
                    React.createElement("div", { className: "right" }, (updatelist.filter((cke) => (cke.checked)).length <= 0) ?
                        React.createElement("button", { type: "button", className: "bg-gray", disabled: true },
                            React.createElement("span", null, t("LABEL.저장")))
                        :
                            React.createElement("button", { type: "button", className: "bg-blue js-open", "data-pop": "pop-change", onClick: (e) => savedPop(e, updatelist) },
                                React.createElement("span", { "data-pop": "pop-change" }, t("LABEL.저장"))))),
                React.createElement("div", { className: "tbl-list type2 td-h26 h530 scrollH" },
                    React.createElement("table", { summary: "\uC120\uD0DD,No.,\uC810\uAC80\uB2E8\uACC4,\uD56D\uBAA9,\uC9C4\uB2E8\uC810\uAC80 \uACB0\uACFC \uAC12,\uC0AC\uC6A9\uC790 \uC785\uB825 \uAC12 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC124\uC815 \uD56D\uBAA9 \uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                        React.createElement("caption", null, "\uC124\uC815 \uD56D\uBAA9 \uBAA9\uB85D"),
                        React.createElement("colgroup", null,
                            React.createElement("col", { style: { "width": "5%" } }),
                            React.createElement("col", { style: { "width": "5%" } }),
                            React.createElement("col", { style: { "width": "8%" } }),
                            React.createElement("col", { style: {} }),
                            React.createElement("col", { style: {} }),
                            React.createElement("col", { style: { "width": "22%" } })),
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { scope: "col", className: "txt-left" }, t("FIELD.선택")),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    t("FIELD.No"),
                                    "."),
                                React.createElement("th", { scope: "col", className: "txt-left" }, t("FIELD.점검단계")),
                                React.createElement("th", { scope: "col", className: "txt-left" }, t("FIELD.항목")),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    t("FIELD.진단점검결과값"),
                                    " "),
                                React.createElement("th", { scope: "col", className: "txt-left" },
                                    t("FIELD.사용자입력값"),
                                    " "))),
                        React.createElement("tbody", null, (updatelist) && updatelist.map((list, idx) => (React.createElement("tr", { key: "life_" + idx.toString() },
                            React.createElement("td", { className: "txt-left" },
                                React.createElement("input", { type: "checkbox", id: "t_" + list.number, checked: (list.checked) ? true : false, onChange: (e) => checkedList(e.target.checked, list.number) }),
                                React.createElement("label", { htmlFor: "t_" + list.number },
                                    React.createElement("span", { className: "hide" }, "\uC120\uD0DD"))),
                            React.createElement("td", { className: "txt-left" }, (list.number) ? list.number : "-"),
                            React.createElement("td", { className: "txt-left" }, (list.stepName) ? list.stepName : "-"),
                            (list.stepName == "User Defined") ?
                                React.createElement("td", { className: "txt-left" },
                                    React.createElement("div", { className: "input__area w85p" },
                                        (list.checked == true) &&
                                            React.createElement("input", { type: "text", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.항목값")]), id: "checkItemName" + list.number, value: (CUTIL.isnull(list.checkItemNamed)) ? (CUTIL.isnull(list.checkItemName)) ? "" : list.checkItemName : list.checkItemNamed, onChange: (e) => handleCheckItemName(e, list.number) }),
                                        (list.checked == false) &&
                                            React.createElement("input", { type: "text", disabled: true, id: "checkItemName" + list.number })))
                                :
                                    React.createElement("td", { className: "txt-left", id: "checkItemName" + list.number },
                                        React.createElement("p", { className: "ellipsis w100p" }, (list.checkItemName) ? list.checkItemName : "-")),
                            React.createElement("td", { className: "txt-left" },
                                React.createElement("p", { className: "ellipsis w100p" }, (list.refAnswer) ? list.refAnswer : "-")),
                            React.createElement("td", { className: "txt-left" },
                                React.createElement("div", { className: "input__area" },
                                    (list.checked == true) &&
                                        React.createElement("input", { type: "text", placeholder: t("MESSAGE.T1입력하세요", [t("MESSAGE.설정값")]), className: "input-error", id: "userInput" + list.number, value: (CUTIL.isnull(list.userInput)) ? (CUTIL.isnull(list.deviceLife.userInput)) ? "" : list.deviceLife.userInput : list.userInput, onChange: (e) => handleUserInput(e, list.number) }),
                                    (list.checked == false) &&
                                        React.createElement("input", { type: "text", disabled: true, id: "userInput" + list.number }),
                                    React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "userInput")).map((err) => err.msg)))))))))),
                React.createElement("div", { className: "tbl__bottom inline right" },
                    React.createElement("p", { className: "txt-info" }, "* '-' \uD45C\uC2DC \uD56D\uBAA9\uC740 \uC9C4\uB2E8\uC810\uAC80 \uACB0\uACFC\uAC00 \uC5C6\uC5B4\uC11C \uD45C\uC2DC\uD558\uC9C0 \uC54A\uC558\uC2B5\uB2C8\uB2E4."))))));
}
export default DeviceLifeUpdate;
function ChanagePop(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setRecoilIsLoadingBox = props.setRecoilIsLoadingBox;
    //props
    const item = props.item;
    const listItem = props.listItem;
    const setParentWorkMode = props.setParentWorkMode;
    //
    const [success, setSuccess] = useState([]);
    const [changeFail, setChangeFail] = useState([]);
    function changeDone(id, item, itemIdPk) {
        return __awaiter(this, void 0, void 0, function* () {
            let checkItems = item;
            setRecoilIsLoadingBox(true);
            if (checkItems.filter((chek) => (chek.checkItemId) && (chek.userInput)).length +
                checkItems.filter((chek) => (!chek.checkItemId) && ((chek.userInput) && (chek.checkItemName))).length !== item.length) {
                alert("체크된 항목에 입력이 안된 항목이 있습니다.");
                CUTIL.jsclose_Popup(id);
                setRecoilIsLoadingBox(false);
                var num = [];
                checkItems.forEach(el => {
                    if ((!el.userInput)) {
                        num.push({
                            userInput: el.userInput,
                            number: el.number
                        });
                    }
                    else if ((!el.checkItemId) && !el.checkItemName) {
                        num.push({
                            userInput: el.userInput,
                            checkItemName: el.checkItemName,
                            number: el.number,
                        });
                    }
                });
                if (!num[0].userInput) {
                    document.getElementById("userInput" + num[0].number).focus();
                }
                else if (!num[0].checkItemName) {
                    document.getElementById("checkItemName" + num[0].number).focus();
                }
            }
            else {
                let data = [];
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "POST",
                    appPath: `/api/v2/assessment/devicelife`,
                    appQuery: {
                        itemIdPk: itemIdPk,
                        putIn: checkItems.map((el) => ({
                            checkItemId: el.checkItemId,
                            userInput: el.userInput,
                            checkItemName: el.checkItemName,
                            number: el.number
                        }))
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        var btnCommentClose = document.getElementById(id);
                        if (!CUTIL.isnull(btnCommentClose))
                            btnCommentClose.classList.add("hidden");
                        setRecoilIsLoadingBox(false);
                        setSuccess(data.data.msg);
                        if (!CUTIL.isnull(btnCommentClose))
                            btnCommentClose.classList.remove("hidden");
                    }
                }
            }
        });
    }
    function popDone(id) {
        setSuccess([]);
        CUTIL.jsclose_Popup(id);
        setParentWorkMode("READ");
    }
    function PopCloses(id) {
        setSuccess([]);
        CUTIL.jsclose_Popup(id);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null, (success.length <= 0) ?
                "저장하시겠습니까 ?"
                :
                    "저장되었습니다.")),
        React.createElement("div", { className: "popup__footer" },
            (success.length <= 0) &&
                React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => PopCloses("pop-change") },
                    React.createElement("span", null, "\uCDE8\uC18C")),
            (success.length > 0) ?
                React.createElement("button", { type: "button", className: "js-close", onClick: (e) => popDone("pop-change") },
                    React.createElement("span", null, "\uD655\uC778"))
                :
                    React.createElement("button", { type: "button", onClick: (e) => changeDone("pop-change", item.curItem, listItem.itemIdPk) },
                        React.createElement("span", null, "\uD655\uC778")))));
}
